(function () {
    'use strict';

    angular.module('swif.framework')
        .factory('CacheService', CacheService);

    /**
     * @ngdoc service
     * @name swif.framework.CacheService
     * Cache system - we have declare each request we authorize in cache
     **/
    function CacheService($cacheFactory) {
        'ngInject';
        var service = {};

        service.cache = $cacheFactory('cacheId');

        service.put = function(key, value) {
            var sanitizedKey = getSanitizedKeyFromResponse(key);
            // Be careful, props needs to be in the same order
            if(isCacheAuthorized(service.cachableKeys, sanitizedKey)){
                //for a same key, we over-right the value
                service.cache.put(sanitizedKey, angular.isUndefined(value) ? null : angular.copy(value));
            }
        };

        service.get = function(key) {
            var sanitizedKey = getSanitizedKeyFromRequest(key);
            if(isCacheAuthorized(service.cachableKeys, sanitizedKey)){
                return angular.copy(service.cache.get(sanitizedKey));
            }else{
                return null;
            }
        };

        service.remove = function(key) {
            service.cache.remove(key);
        };

        service.removeAll = function() {
            service.cache.removeAll();
        };

        service.deleteContentTypeValues = function(contentType) {
            //we delete all the keys in cache who have this content type
            service.cachableKeys.forEach(function (key){
                if (_.contains(key, contentType)){
                    service.remove(key);
                }
            });
        };

        function getSanitizedKeyFromRequest(key) {
            var sanitizedKey = {
                'domain': key.params.domain,
                'fields': key.params.fields,
                'limit': key.params.limit,
                'model': key.params.model,
                'sort': key.params.sort,
                'url': key.url
            };
            return JSON.stringify(sanitizedKey);
        }

        function getSanitizedKeyFromResponse(key) {
            var sanitizedKey = {
                'domain': key.data.params.domain,
                'fields': key.data.params.fields,
                'limit': key.data.params.limit,
                'model': key.data.params.model,
                'sort': key.data.params.sort,
                'url': key.url
            };
            return JSON.stringify(sanitizedKey);
        }

        function isCacheAuthorized(keys, sanitizedKey){
            return _.some(keys, function(key) {
                return key === sanitizedKey;
            })
        }

        service.cachableKeys = [];
        service.cachableKeys.push(JSON.stringify({
            'fields':["task_default_hours","task_default_report_hours","intervention_window_synchronize_status",
                "add_intervention_window_create_task","add_task_window_advanced_mode",
                'task_patrimony_tab_enable','task_patrimony_tab_required', 'task_notify', 'task_notify_default_value',
                "validate_request_window_advanced_mode", "task_in_validate_request_window_advanced_mode",
                "task_in_create_intervention_window_advanced_mode", "request_priority_require", "request_priority_enable",
                "project_template_enable","project_ask_template_require", "task_range_enable", "processing_times_enable",
                "project_ask_template_require"],

            'model':'res.company',
            'url':'/web/dataset/get'
        }));

        service.cachableKeys.push(JSON.stringify({
            'fields':["currency_id"],
            'model':'res.company',
            'url':'/web/dataset/get'
        }));
        //add here all the request model you want to authorize in cache
        //examples :
        //
        // service.cachableKeys.push(JSON.stringify({
        //     'model':'openstc.ask',
        //     'url':'/web/searchview/fields_get'
        // }));

        return service;
    }
})();
